import stuart from '../../assets/testimonials/stuart.png'
import akash from '../../assets/testimonials/akash.jpeg'
import will from '../../assets/testimonials/will.jpeg'
import anas from '../../assets/testimonials/anas.jpeg'
import nazanin from '../../assets/testimonials/nazanin.jpeg'
import alex from '../../assets/testimonials/alex.jpeg'
import jacy from '../../assets/testimonials/jacy.jpeg'

const featuredTestimonial = {
  body: 'Copybuddy gets me 80-90% of the way there, with a format that’s easy to duplicate.  Saves me hours per week on email writing!',
  author: {
    name: 'Alex Goettel',
    title: 'Founding BDR',
    site: 'https://talogy.com/',
    companyName: 'Talogy',
    imageUrl: alex
  },
}
const testimonials = [
  [
    [
      {
        body: "I've tried a lot of AI-copywriting tools for scripting my cold emails but this tool is a beast. It feels as if a real human has written it.",
        author: {
          name: 'Anas Ansar',
          title: 'Founder',
          site: 'https://koldd.co/',
          companyName: 'Koldd.co',
          imageUrl: anas,
          logoUrl: 'https://tailwindui.com/img/logos/savvycal-logo-gray-900.svg',
        },
      },
      {
        body: 'Huge unlock for our cold outbound campaigns - we’ve been able to A/B test messaging much faster',
        author: {
          name: 'Akash Mandavilli',
          title: 'Founder',
          site: 'https://zenfetch.com/',
          companyName: 'Zenfetch (YC W23)',
          imageUrl: akash
        },
      },
    ],
    [
      {
        body: 'AI written copy for my email campaigns that is actually worth using.',
        author: {
          name: 'Stuart Brent',
          title: 'Founder',
          site: 'https://www.saasydb.com/',
          companyName: 'SaasyDB',
          imageUrl: stuart,
          logoUrl: 'https://tailwindui.com/img/logos/savvycal-logo-gray-900.svg',
        },
      },
    ],
  ],
  [
    [
      {
        body: 'Absolutely love copybuddy 5/5',
        author: {
          name: 'Nazanin Ashrafi',
          title: 'Creator',
          site: 'https://twitter.com/nazanin_ashrafi',
          companyName: 'X',
          imageUrl: nazanin,
          logoUrl: 'https://tailwindui.com/img/logos/savvycal-logo-gray-900.svg',
        },
      },
    ],
    [
      {
        body: 'This tool produced by far the best AI copy I have seen in professional outreach.',
        author: {
          name: 'Jacy Loshin',
          title: 'BDR',
          site: 'https://www.salesurfgrowth.com/',
          companyName: 'Salesurf Growth',
          imageUrl: jacy
        },
      },
      {
        body: 'I run an agency for my day job. CopyBuddy creates perfect copy and I’ve seen sales increase.  If you send emails, it’s a no brainer.',
        author: {
          name: 'Will Gordon',
          title: 'Founder',
          site: 'https://starterbuild.com/',
          companyName: 'StarterBuild',
          imageUrl: will,
          logoUrl: 'https://tailwindui.com/img/logos/savvycal-logo-gray-900.svg',
        },
      },
    ],
  ],
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Testimonials() {
  return (
    <div className="relative isolate bg-white pb-12 pt-24 sm:pt-32">
      {/* <div
        className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl"
        aria-hidden="true"
      >
        <div
  className="ml-[max(50%,38rem)] aspect-[1313/771] w-[82.0625rem] bg-gradient-to-tr from-custom-orange to-yellow-500"
  style={{
    clipPath:
      'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
  }}
/>
      </div>
      <div
        className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end"
        aria-hidden="true"
      >
       <div
  className="ml-[-22rem] aspect-[1313/771] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] bg-gradient-to-tr from-custom-orange to-yellow-500 xl:ml-0 xl:mr-[calc(50%-12rem)]"
  style={{
    clipPath:
      'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
  }}
/>
      </div> */}
      <div className="mx-auto max-w-7xl px-6 lg:px-8 pb-12">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-lg font-semibold leading-8 tracking-tight text-custom-orange">Testimonials</h2>
          <p className="mt-2 text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
            We've helped 400+ businesses write emails
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 grid-rows-1 gap-8 text-sm leading-6 text-gray-900 sm:mt-20 sm:grid-cols-2 xl:mx-0 xl:max-w-none xl:grid-flow-col xl:grid-cols-4">
          <figure className="bg-white rounded-xl shadow-2xl sm:col-span-2 xl:col-start-2 xl:row-end-1 p-6">
            <blockquote className="text-lg font-semibold text-gray-900 sm:p-12 sm:text-xl sm:leading-8">
              <p>{`“${featuredTestimonial.body}”`}</p>
            </blockquote>
            <figcaption className="flex flex-wrap items-center gap-x-4 gap-y-4 border-gray-900/10 sm:flex-nowrap">
              <img
                className="h-10 w-10 flex-none rounded-full bg-gray-50"
                src={featuredTestimonial.author.imageUrl}
                alt=""
              />
              <div className="flex-auto">
                <div className="font-semibold">{featuredTestimonial.author.name}</div>
                <div className="text-gray-600">{featuredTestimonial.author.title} @ <a href={featuredTestimonial.author.site} className="text-custom-orange hover:underline">{featuredTestimonial.author.companyName}</a></div>
              </div>
              {/* <img className="h-10 w-auto flex-none" src={featuredTestimonial.author.logoUrl} alt="" /> */}
            </figcaption>
          </figure>
          {testimonials.map((columnGroup, columnGroupIdx) => (
            <div key={`columnGroup-${columnGroupIdx}`} className="space-y-8 xl:contents xl:space-y-0">
              {columnGroup.map((column, columnIdx) => (
                <div
                  key={`column-${columnIdx}`}
                  className={classNames(
                    (columnGroupIdx === 0 && columnIdx === 0) ||
                      (columnGroupIdx === testimonials.length - 1 && columnIdx === columnGroup.length - 1)
                      ? 'xl:row-span-2'
                      : 'xl:row-start-1',
                    'space-y-8'
                  )}
                >
                  {column.map((testimonial) => (
                    <figure
                      key={testimonial.author.name} // Use a unique property of the testimonial as the key
                      className="bg-white rounded-xl shadow-2xl p-6"
                    >
                      <blockquote className="text-gray-900">
                        <p>{`“${testimonial.body}”`}</p>
                      </blockquote>
                      <figcaption className="mt-6 flex items-center gap-x-4">
                        <img className="h-10 w-10 rounded-full bg-gray-50" src={testimonial.author.imageUrl} alt="" />
                        <div>
                          <div className="font-semibold">{testimonial.author.name}</div>
                          <div className="text-gray-600">{testimonial.author.title} @ <a href={testimonial.author.site} className="text-custom-orange hover:underline">{testimonial.author.companyName}</a></div>
                        </div>
                      </figcaption>
                    </figure>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
